<template>
  <span class="svg-icon-commo-chat">
    <svg :width="width" :height="width" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_10422_210579)">
    <path d="M6.71107 15.7907H4.18396C3.84885 15.7907 3.52746 15.6576 3.2905 15.4206C3.05353 15.1836 2.92041 14.8622 2.92041 14.5271V9.47291C2.92041 9.13779 3.05353 8.8164 3.2905 8.57944C3.52746 8.34248 3.84885 8.20935 4.18396 8.20935H6.71107L11.1335 2.52336C11.2439 2.30885 11.4275 2.14091 11.6509 2.0499C11.8744 1.95889 12.123 1.9508 12.3519 2.02709C12.5808 2.10339 12.7748 2.25904 12.899 2.46592C13.0231 2.6728 13.0692 2.91727 13.0288 3.15514V20.8449C13.0692 21.0828 13.0231 21.3272 12.899 21.5341C12.7748 21.741 12.5808 21.8966 12.3519 21.9729C12.123 22.0492 11.8744 22.0411 11.6509 21.9501C11.4275 21.8591 11.2439 21.6912 11.1335 21.4767L6.71107 15.7907Z" :stroke="color" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15.2931 9.66669C15.912 9.66669 16.5055 9.91252 16.943 10.3501C17.3806 10.7877 17.6265 11.3812 17.6265 12C17.6265 12.6189 17.3806 13.2124 16.943 13.65C16.5055 14.0876 15.912 14.3334 15.2931 14.3334" :stroke="color" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M16.5537 6.54675C17.8437 6.54675 19.0808 7.12129 19.9929 8.14397C20.9051 9.16665 21.4175 10.5537 21.4175 12C21.4175 13.4463 20.9051 14.8333 19.9929 15.856C19.0808 16.8787 17.8437 17.4532 16.5537 17.4532" :stroke="color" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_10422_210579">
    <rect :width="24" :height="24" fill="white"/>
    </clipPath>
    </defs>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return '#FF2E38' } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean },
  }
}
</script>